module.exports = __webpack_public_path__ + "img/kel-unid-joinville.464fb3a5.jpeg";